import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router,
Routes,
Route,
Link} from 'react-router-dom';
import Home from './component/home';
import About from './component/about';
import MCTermsConditions from './component/mcTerms&Condition';
import PrivacyPolicy from './component/privacy-policy'
import CookiePolicy from './component/cookies-policy';
import MVatuPrivacyPolicy from './component/MVatu/privacy-policy';
import MVatuCookiePolicy from './component/MVatu/cookies-policy'
import MPSTermsConditions from './component/termsandconditions';
import MTalaTermsConditions from './component/MTala/termsandconditions';
import MTalaPrivacyPolicy from './component/MTala/privacy-policy';
import EMoniPrivacyPolicy from './component/EMoni/privacy-policy';
import EMoniTermsConditions from './component/EMoni/termsandconditions';
import MPSKITermsConditions from './component/MPAiSAKiribati/termsandconditions';
import MPSKIPrivacyPolicy from './component/MPAiSAKiribati/privacy-policy';

function App() {
  return (
    <Router>
      <div className="App"/>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/mpaisamastertermsconditions' element={<MCTermsConditions/>}/>
        <Route path='/termsandconditions' element={<MPSTermsConditions/>}/>
        <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
        <Route path='/cookies-policy' element={<CookiePolicy/>}/>
        <Route path='/vu/privacy-policy' element={<MVatuPrivacyPolicy/>}/>
        <Route path='/vu/cookies-policy' element={<MVatuCookiePolicy/>}/>
        <Route path='/ws/termsandconditions' element={<MTalaTermsConditions/>}/>
        <Route path='/ws/privacy-policy' element={<MTalaPrivacyPolicy/>}/>
        <Route path='/ck/privacy-policy' element={<EMoniPrivacyPolicy/>}/>
        <Route path='/ck/termsandconditions' element={<EMoniTermsConditions/>}/>
        <Route path='/ki/privacy-policy' element={<MPSKIPrivacyPolicy/>}/>
        <Route path='/ki/termsandconditions' element={<MPSKITermsConditions/>}/>
      </Routes> 
    </Router>
  );
}

export default App;
